// 1. Combined all react-router-dom imports into a single line
import { Link, Outlet, useLocation, useParams } from "react-router-dom";

import { IoAddCircleOutline } from "react-icons/io5";
import { Layout } from "../components/section";
import { PageHeader } from "../components/header";

export const Careers = () => {
  const location = useLocation();
  const params = useParams();

  // 2. Extract complex routing logic into a cleanly named boolean variable
  const isCreatePage = location.pathname.includes("create");
  const isEditPage = Boolean(params.slug);
  const showAddButton = !isCreatePage && !isEditPage;

  return (
    <>
      <PageHeader title="Careers">
        {showAddButton && (
          <Link
            to="/careers/create"
            title="Post New Role"
            aria-label="Post New Role"
          >
            <IoAddCircleOutline />
          </Link>
        )}
      </PageHeader>

      <Layout>
        <Outlet />
      </Layout>
    </>
  );
};
